import { LS2PacMain } from "./tlc/ls2pac/ls2pac-main";

$(function() {
	LS2PacMain.start();
});
